import config from '../config/config';
import { CryptoNewsData } from '../types/coindesk';

interface NewsApiParams {
  categories?: string[];
  limit?: number;
  lang?: string;
}

class NewsApi {
  static async getNewsData({ categories = [], limit = 10, lang = 'EN' }: NewsApiParams = {}): Promise<
    CryptoNewsData[]
  > {
    try {
      const params = new URLSearchParams({
        lang,
        limit: limit.toString(),
      });

      if (categories.length > 0) {
        params.append('categories', categories.join(','));
      }

      const response = await fetch(`${config.get('coindesk.baseUrl')}/article/list?${params}`, {
        // headers: {
        //   'x-api-key': config.get('coindesk.credentials'),
        //   'Content-Type': 'application/json',
        // },
      });

      if (!response.ok) {
        throw new Error(`CoinDesk API error: ${response.status}`);
      }

      const data: CryptoNewsData[] = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching news data:', error instanceof Error ? error.message : String(error));
      throw error;
    }
  }
}

export default NewsApi;
